"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _utils = require("@ori-ui/mui-bundle/material/utils");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _utils.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 3.75a5.154 5.154 0 0 0-3.456 8.982c.2.194.362.946.362 1.675v2.234c0 .853.694 1.547 1.547 1.547v.516c0 .853.694 1.547 1.547 1.547s1.547-.694 1.547-1.547v-.516c.853 0 1.547-.694 1.547-1.547v-2.234c0-.742.158-1.478.343-1.66a5.16 5.16 0 0 0 1.719-3.841A5.16 5.16 0 0 0 12 3.75m.516 14.953a.517.517 0 0 1-1.032 0v-.516h1.031zm1.031-1.547h-3.094a.517.517 0 0 1-.516-.516v-.516h4.125v.516a.517.517 0 0 1-.516.516zm.516-2.062H9.938v-1.031h-.01l-.002-.032h4.148l-.002.032h-.01v1.031zm.671-3.101c-.252.246-.41.62-.508 1.006H9.772c-.101-.389-.264-.768-.523-1.02a4.14 4.14 0 0 1-1.374-3.073c0-2.275 1.851-4.125 4.125-4.125s4.125 1.85 4.125 4.125a4.14 4.14 0 0 1-1.391 3.087"
}), 'Lightbulb');
